import React from 'react'
import BoxingInJapanComp from '../../components/sponsorships/BoxingInJapan'

const BoxingInJapan = () => {
  return (
    <BoxingInJapanComp/>
  )
}

export default BoxingInJapan